export function setModalOpened(status, processed) {
  return {
    type: "@modal_bought/SET_MODAL_OPENED",
    payload: { status, processed },
  };
}
